"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardPlate = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const components_1 = require("@veeam/components");
const FeatureContext_1 = require("../../core/contexts/FeatureContext");
const external_svg_1 = __importDefault(require("../../assets/icons/external.svg"));
require("./types");
const components_2 = require("./components");
const HeaderAddonWrapper = styled_components_1.default.div `
  display: flex;
  max-height: ${components_1.SIZE_XL};
`;
const TitleWrapper = styled_components_1.default.div `
  display: flex;
`;
const Header = styled_components_1.default(components_1.StackView) `
  margin-top: ${components_1.SPACING_M};
  margin-bottom: ${components_1.SPACING_S};
`;
const Body = styled_components_1.default.div `
  overflow: auto;
  margin-top: ${components_1.SPACING_S};
`;
const HeaderBodyWrapper = styled_components_1.default(components_1.StackView) `
  ${({ hasViewMore }) => {
    if (hasViewMore) {
        return styled_components_1.css `
        height: calc(100% - ${components_1.SPACING_XL} - ${components_1.SPACING_S});
      `;
    }
    return styled_components_1.css `
      height: 100%;
    `;
}}
`;
const Footer = styled_components_1.default(components_1.StackView) `
  height: ${components_1.SPACING_XL};
  margin-bottom: ${components_1.SPACING_S};
`;
const Root = styled_components_1.default(components_1.StackView) `
  display: inline-flex;
  position: relative;
  box-sizing: border-box;
  min-width: 544px;
  height: 368px;

  background-color: #fff;
`;
const DashboardPlate = ({ title, headerAddon, content, hasViewMore = false, viewMoreIcon = external_svg_1.default, onShowMoreClick, texts, }) => {
    const { t } = FeatureContext_1.useFeatureContext();
    return (react_1.default.createElement(Root, { direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.firstFill, spaceHorizontal: components_1.INDENT.m },
        react_1.default.createElement(HeaderBodyWrapper, { hasViewMore: hasViewMore, direction: components_1.STACK_DIRECTION.column, distribution: components_1.STACK_DISTRIBUTION.lastFill },
            react_1.default.createElement(Header, { indentLeft: components_1.INDENT.s, gap: components_1.STACK_GAP.m, align: components_1.STACK_ALIGN.center, size: { height: '20px' }, distribution: components_1.STACK_DISTRIBUTION.lastFill },
                react_1.default.createElement(TitleWrapper, null,
                    react_1.default.createElement(components_2.Title, { text: title })),
                headerAddon && react_1.default.createElement(HeaderAddonWrapper, null, headerAddon)),
            react_1.default.createElement(Body, null, content)),
        hasViewMore && (react_1.default.createElement(Footer, null,
            react_1.default.createElement(components_1.Spacer, null),
            react_1.default.createElement(components_1.LinkButton, { iconBefore: viewMoreIcon, onClick: onShowMoreClick }, (texts === null || texts === void 0 ? void 0 : texts.viewMore) || t('dashboardPlate|viewMore|text'))))));
};
exports.DashboardPlate = DashboardPlate;
//# sourceMappingURL=DashboardPlate.js.map